<template>
	<div>
		<div style="color: #3e3e3e; font-size: 18px; margin-bottom: 15px;">
			用户管理>用户运营>用户运营-设置人群
		</div>
		<div class="wais">
			<div class="wai">
				<div class="title">
					<div class="blue"></div>
					<div style="flex: 1;">基本设置</div>
				</div>
				<el-form label-width="120px">
					<el-form-item label="会员卡名称">
						<div style="display: flex;" class="list1">
							<el-input v-model="member.title" size="small" maxlength="10" show-word-limit
								placeholder="请输入会员名称" style="margin-right: 10px;width: 300px;"></el-input>
						</div>
					</el-form-item>
					<div class="title">
						<div class="blue"></div>
						<div style="flex: 1;">会员规格</div>
					</div>
					<el-form-item>
						<div>
							<div style="display: flex;">
								有限期
								<el-select style="margin-left: 20px;" v-model="member.valid" size="small"
									placeholder="请选择">
									<el-option v-for="item in timeType" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</div>
						<div style="display: flex;margin-top: 20px;">
							<span>价格</span>
							<el-input type="number" :min="0" placeholder="输入会员价格" v-model="member.price" size="small"
								style="width: 200px;margin-left:30px;margin-right: 10px;"></el-input>
							<span>元</span>
						</div>
					</el-form-item>
					<div class="title">
						<div class="blue"></div>
						<div style="flex: 1;">会员权益</div>
					</div>
					<el-form-item style="margin-top: -20px;">
						<div style="position: absolute; left: -90px">
							主权益设置
						</div>
						<div style="display: flex;width:500px;">
							<el-input v-model="member.discount"></el-input>
							<!-- 							<el-input type="text" size="small" placeholder="输入折扣" style="width: 150px;margin-left: 20px;" v-model="member.discount">
							</el-input> -->
							<!-- <span style="margin-left: 5px;">折</span> -->
						</div>
						<!-- 						<div>
							<el-radio v-model="member.allService" :label="1">全部剪发服务</el-radio>
						</div>
						<div>
							<el-radio v-model="member.allService" :label="0">部分服务可选</el-radio>
							<el-tag type="primary" v-for="i in selectService" :key="i.id" style="margin-right:10px">{{ i.title }}</el-tag>
							<el-button class="adds" size="mini" :disabled="member.allService==1" @click="serviceListWindow=true">＋添加服务</el-button>
						</div> -->
					</el-form-item>
					<el-form-item>
						<div style="position: absolute; left: -95px">
							附属权益设置
						</div>
						<div>
							<el-button size="mini" @click="couponWindow=true">＋添加劵</el-button>
						</div>
					</el-form-item>
					<el-form-item label="会员卡面上传">
						<div style="display: flex;">
							<upload id="upload" v-model="member.image" style="width: 150px;height: 110px;"></upload>
							<div class="mberupload">
								<el-button type="primary" size="small" @click="butupload">选择文件</el-button>
								<p>建议尺寸456*234px或1.95:1，JPG、PNG格式，图片小于1M</p>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="会员权益详情">
						<div v-if="!couponWindow && !serviceListWindow">
							<!-- <VueUeditorWrap v-model="member.details" :config="ueditor_config" /> -->
							<quill-editor v-model="member.details" ref="myQuillEditor" style="height: 500px;">
							</quill-editor>
						</div>
					</el-form-item>
				</el-form>
				<div class="button_s">
					<el-button size="small" @click="$router.push('/product_user')">取 消</el-button>
					<el-button type="primary" size="small" @click="edit">保 存</el-button>
				</div>
			</div>
			<div class="wai2">
				<div class="demo2">
					<img src="../../assets/phone1.png" />
				</div>
			</div>
		</div>
		<el-dialog title="选择服务" :visible.sync="serviceListWindow" width="20%">
			<div v-for="item in serviceList" :key="item.id">
				<el-checkbox v-model="selectService" :label="item">{{ item.title }}</el-checkbox>
			</div>
			<div style="position: relative; left:70%;">
				<el-button type="primary" @click="serviceListWindow=false">确认</el-button>
			</div>
		</el-dialog>
		<el-dialog title="选择优惠劵" :visible.sync="couponWindow" width="50%">
			<el-form inline>
				<el-form-item>
					<el-input v-model="couponFilter.name"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getCouponList">筛选</el-button>
				</el-form-item>
			</el-form>
			<el-tabs v-model="couponType" type="card" @tab-click="updateCouponType">
				<el-tab-pane label="满减劵" name="0"></el-tab-pane>
				<el-tab-pane label="折扣劵" name="1"></el-tab-pane>
				<el-tab-pane label="商品劵" name="2"></el-tab-pane>
				<el-tab-pane label="积分劵" name="3"></el-tab-pane>
			</el-tabs>
			<el-table :data="couponList" height="500">
				<el-table-column label="选择" width="50">
					<template slot-scope="scope">
						<el-checkbox-group v-model="selectCoupon" style="width: 20px; overflow: hidden;">
							<el-checkbox :label="scope.row.id"></el-checkbox>
						</el-checkbox-group>
					</template>
				</el-table-column>
				<el-table-column prop="title" label="劵名称">
					<template slot-scope="scope">
						{{ scope.row.title }}
					</template>
				</el-table-column>
				<el-table-column prop="storeNames" label="使用范围">
					<template slot-scope="scope">
						{{ scope.row.storeNames.toString() }}
					</template>
				</el-table-column>
				<el-table-column prop="content" label="劵内容" width="120">
					<template slot-scope="scope">
						{{ scope.row.content }}
					</template>
				</el-table-column>
				<el-table-column prop="termOfValidity" label="有效期" width="180">
					<template slot-scope="scope">
						{{ scope.row.termOfValidity }}
					</template>
				</el-table-column>
				<el-table-column label="领取/总量" width="120">
					<template slot-scope="scope">
						{{ scope.row.getNum }} / {{ scope.row.totalNum }}
					</template>
				</el-table-column>
				<el-table-column prop="useNum" label="已使用" width="80">
					<template slot-scope="scope">
						{{ scope.row.useNum }}
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background @current-change="couponPage" layout="prev, pager, next"
				:total="couponFilter.total">
			</el-pagination>
			<el-button style="margin-left:70%" @click="couponWindow=false">取消</el-button>
			<el-button type="primary" @click="couponWindow=false">确定</el-button>
		</el-dialog>
	</div>
</template>
<script>
	import VueUeditorWrap from 'vue-ueditor-wrap'
	import {
		ueditor_config
	} from '@/utils/index'
	import {
		quillEditor
	} from 'vue-quill-editor'
	import upload from "../compents/upload/upload.vue"
	export default {
		components: {
			upload,
			VueUeditorWrap,
			quillEditor
		},
		data() {
			return {
				member: {
					id: undefined,
					title: undefined,
					price: undefined,
					valid: undefined,
					allService: undefined,
					service: [],
					details: undefined,
					image: undefined,
					discount: '',
					coupon: undefined,
				},
				serviceListWindow: false,
				serviceList: [],
				selectService: [],
				selectCoupon: [],
				couponList: [],
				couponType: undefined,
				couponWindow: false,
				couponFilter: {
					name: undefined,
					pageNum: 1,
					pageSize: 10,
					total: 0,
				},
				timeType: [{
					value: '12',
					label: '一年'
				}, {
					value: '6',
					label: '半年'
				}, {
					value: '3',
					label: '三个月'
				}, ],
				// 富文本
				ueditor_config,
				ueConfig: {
					toolbars: [
						[
							'undo', //撤销
							'bold', //加粗
							'indent', //首行缩进
							'italic', //斜体
							'underline', //下划线
							'strikethrough', //删除线
							'subscript', //下标
							'fontborder', //字符边框
							'superscript', //上标
							'formatmatch', //格式刷
							'fontfamily', //字体
							'fontsize', //字号
							'justifyleft', //居左对齐
							'justifycenter', //居中对齐
							'justifyright', //居右对齐
							'justifyjustify', //两端对齐
							'insertorderedlist', //有序列表
							'insertunorderedlist', //无序列表
							'lineheight', //行间距
						]
					],
					'fontfamily': [{
						label: '',
						name: 'songti',
						val: '宋体,SimSun'
					}, {
						label: '仿宋',
						name: 'fangsong',
						val: '仿宋,FangSong'
					}, {
						label: '仿宋_GB2312',
						name: 'fangsong',
						val: '仿宋_GB2312,FangSong'
					}, {
						label: '',
						name: 'kaiti',
						val: '楷体,楷体_GB2312, SimKai'
					}, {
						label: '',
						name: 'yahei',
						val: '微软雅黑,Microsoft YaHei'
					}, {
						label: '',
						name: 'heiti',
						val: '黑体, SimHei'
					}, {
						label: '',
						name: 'lishu',
						val: '隶书, SimLi'
					}, {
						label: '',
						name: 'andaleMono',
						val: 'andale mono'
					}, {
						label: '',
						name: 'arial',
						val: 'arial, helvetica,sans-serif'
					}, {
						label: '',
						name: 'arialBlack',
						val: 'arial black,avant garde'
					}, {
						label: '',
						name: 'comicSansMs',
						val: 'comic sans ms'
					}, {
						label: '',
						name: 'impact',
						val: 'impact,chicago'
					}, {
						label: '',
						name: 'timesNewRoman',
						val: 'times new roman'
					}],
					// 初始容器高度
					initialFrameHeight: 200,
					// 初始容器宽度
					initialFrameWidth: '100%',
					// 上传文件接口
					enableAutoSave: false,
					elementPathEnable: false,
					wordCount: false,
				}
			}
		},
		computed: {},
		methods: {
			couponPage(val) {
				this.couponFilter.pageNum = val;
				this.getCouponList();
			},
			updateCouponType() {},
			getCouponList() {
				let str = "?pageNum=" + this.couponFilter.pageNum + "&pageSize=" + this.couponFilter.pageSize;
				if (this.couponFilter.name) str += "&name=" + this.couponFilter.name;
				this.$http.get("dCoupon/list" + str).then(res => {
					this.couponList = res.body.data
					this.couponFilter.total = res.body.total
				})
			},
			edit() {
				if (this.member.allService == 0) {
					let ids = [];
					if (!this.selectService.length) return this.$message.error("请选择服务!");
					this.selectService.map(s => ids.push(s.id));
					this.member.service = ids.toString();
				}
				if (this.selectCoupon) {
					let ids = [];
					// this.selectCoupon.map(s => ids.push(s.id));
					this.member.coupon = this.selectCoupon.toString();
				}
				this.member.service = undefined
				this.$http.post("member/edit", JSON.stringify(this.member)).then(res => {
					if (res.body.code == 200) {
						this.$router.push('/product_user');
					} else {
						this.$message.error(res.body.msg);
					}
				})
			},
			butupload() {
				document.querySelector(".el-upload--picture-card").click();
				document.getElementById("upload").click();
			},
			getServiceList() {
				let page = {
					pageNum: 1,
					pageSize: 9999
				}
				this.$http.post("dhaircut/findDhaircutService", JSON.stringify(page)).then(res => {
					this.serviceList = res.body.data.records;
					this.getMember();
				})
			},
			getMember() {
				this.$http.get("member/get/" + this.member.id).then(res => {
					this.member = res.body.data;
					this.couponOfId(this.member.coupon)
					if (this.member.allService == 0) {
						this.selectService = [];
						this.member.service.split(",").map(service => {
							this.serviceList.map(s => {
								if (s.id == service) this.selectService.push(s);
							})
						})
					}
					this.member.price = this.member.price / 100
				})
			},
			couponOfId(ids) {
				if (!ids) return;
				this.$http.get("dCoupon/listById?id=" + ids).then(res => {
					this.useCoupon = [];
					this.selectCoupon = ids.split(',').map(Number);
					this.useCoupon = res.body.data
					// res.body.data.map(c => this.member.)
				});
			},
		},
		mounted() {
			this.member.id = this.$route.query.id;
			this.getServiceList();
			this.getCouponList();
		},
	};
</script>
<style lang="less" scoped>
	.wailianjie {
		display: flex;

		/deep/ .wailj_title {
			width: 100px;
		}
	}

	.dialog-footer {
		margin-right: 32%;
	}

	.button_s {
		margin-left: 200px;
		margin-top: 120px;
	}

	.list1 {
		>div {
			padding-left: 50px;

			p {
				width: 233px;
				height: 47px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #C8C8C8;
				line-height: 2.1;
			}
		}
	}

	// 标题
	.waititle {
		width: 100%;
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.waititle1 {
			display: flex;
			flex: 1;
		}

		.waititle2 {
			display: flex;
		}

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.wais {
		display: flex;
	}

	.wai2 {
		.demo2 {
			margin-top: 50px;
			position: relative;
			left: 20%;
			margin-left: -175px;
			width: 300px;
			height: 600px;
			border-radius: 7px;
			overflow: hidden;
			margin: auto;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.adds {
		width: 90px;
		height: 28px;
		padding: 0px;
		border: 1px dashed #9D9D9D;
		color: #9D9D9D;
	}

	.addlist {
		display: inline-block;
		margin-top: 10px;
		padding-left: 10px;
		padding-right: 10px;
		position: relative;
		text-align: center;
		border-radius: 5px;
		border: 1px solid black;
		transition: 0.3s;

		&:hover {
			div {
				display: block;
			}
		}

		div {
			display: none;
			cursor: pointer;
			position: absolute;
			top: -8px;
			right: -8px;
			background-color: red;
			color: white;
			border-radius: 50%;
			width: 20px;
			height: 20px;
			text-align: center;
			line-height: 20px;
			font-size: 16px;
		}
	}

	.mberupload {
		margin-left: 40px;

		p {
			width: 300px;
			font-size: 14px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #C8C8C8;
			line-height: 1.6;
		}
	}
</style>